import { Button } from "@chakra-ui/react";
import AppModal from "./AppModal";

/**
 * Modal con vista previa embebida del PDF (`iframe`).
 * Si el origen bloquea iframes (p. ej. X-Frame-Options), usar «Abrir en nueva pestaña».
 *
 * @param {boolean} isOpen
 * @param {() => void} onClose
 * @param {string} [src] — URL absoluta o relativa del PDF
 * @param {string} [title]
 */
export default function PdfModal({
  isOpen,
  onClose,
  src,
  title = "Vista previa PDF",
}) {
  return (
    <AppModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="full"
      scrollBehavior="inside"
      footer={
        <div className="flex w-full flex-wrap items-center justify-end gap-2">
          {src ? (
            <a
              href={src}
              target="_blank"
              rel="noopener noreferrer"
              className="order-2 mr-auto text-sm font-medium text-tertiary-600 hover:underline dark:text-tertiary-300 sm:order-1"
            >
              Abrir en nueva pestaña
            </a>
          ) : null}
          <Button
            colorScheme="brand"
            variant="solid"
            onClick={onClose}
            className="order-1 sm:order-2"
          >
            Cerrar
          </Button>
        </div>
      }
    >
      {src ? (
        <iframe
          title="Vista previa PDF"
          src={src}
          className="w-full rounded-lg border border-gray-200 dark:border-white/10"
          style={{ height: "min(75vh, 800px)", minHeight: "50vh" }}
        />
      ) : (
        <p className="text-sm text-gray-500 dark:text-gray-400">
          No hay URL de PDF.
        </p>
      )}
    </AppModal>
  );
}
